import React from "react";
import PropTypes from "prop-types";

import "./Icon.css";

const Icon = props => <span className={"icon-" + props.icon} />;

Icon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default Icon;



// WEBPACK FOOTER //
// ./frontend/src/components/Icon/index.js